import React from 'react';

const Footer = () => {
    return (
        <footer className="relative w-full bg-black text-white overflow-hidden pt-24 pb-12 border-t border-white/5">
            <div className="container mx-auto px-6 relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-24">
                    <div className="col-span-1 md:col-span-2">
                        <div className="flex items-center gap-2 mb-6">
                            <div className="w-6 h-6 rounded bg-white flex items-center justify-center text-black font-bold text-xs">L</div>
                            <span className="text-lg font-bold tracking-tight">LOOKREACT</span>
                        </div>
                        <p className="text-gray-400 text-sm leading-relaxed max-w-sm">
                            Crafting the next generation of web interfaces. <br />
                            Premium React components for developers who care about design.
                        </p>
                    </div>

                    <div>
                        <h4 className="text-sm font-semibold text-white mb-6 uppercase tracking-wider">Product</h4>
                        <ul className="space-y-3 text-gray-400 text-sm">
                            <li><a href="/components" className="hover:text-white transition-colors">Components</a></li>
                            <li><a href="/" className="hover:text-white transition-colors">Templates</a></li>
                            <li><a href="/" className="hover:text-white transition-colors">Pricing</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-sm font-semibold text-white mb-6 uppercase tracking-wider">Connect</h4>
                        <ul className="space-y-3 text-gray-400 text-sm">
                            <li><a href="/" className="hover:text-white transition-colors">Twitter</a></li>
                            <li><a href="/" className="hover:text-white transition-colors">GitHub</a></li>
                            <li><a href="/" className="hover:text-white transition-colors">Discord</a></li>
                        </ul>
                    </div>
                </div>

                <div className="flex flex-col md:flex-row justify-between items-center text-xs text-gray-600 pt-8 border-t border-white/5">
                    <p>&copy; {new Date().getFullYear()} LookReact Labs. All rights reserved.</p>
                    <div className="flex gap-6 mt-4 md:mt-0">
                        <a href="/" className="hover:text-gray-400 transition-colors">Privacy Policy</a>
                        <a href="/" className="hover:text-gray-400 transition-colors">Terms of Service</a>
                    </div>
                </div>
            </div>

            {/* Big Floating Text */}
            <div className="absolute bottom-0 left-0 w-full overflow-hidden pointer-events-none opacity-[0.2] select-none">
                <h1 className="text-[20vw] font-bold leading-none text-center whitespace-nowrap text-white tracking-tighter transform translate-y-[10%]">
                    LOOKREACT
                </h1>
            </div>
        </footer>
    );
};

export default Footer;
